export default "__VITE_ASSET__D9DHrI4h__"